import { DocumentOutputPurpose } from 'models/documentOutputLocation';
import { DocumentProviderType } from 'models/documentProvider';

// Where a report file will be saved by default (PLAN-069): the category, the folder in it and the file name the
// server resolved from the output location row. The server resolves it again at the save.
export class ReportSaveLocation {
  listId: number;

  listName: string;

  providerType: DocumentProviderType;

  // undefined for the category root
  folderId?: string;

  // the readable path of the folder inside the category
  folderName?: string;

  fileName: string;

  constructor() {
    this.listId = 0;
    this.listName = '';
    this.providerType = DocumentProviderType.SharePoint;
    this.fileName = '';
  }
}

// A save to the library: a chosen category (and folder), or the default location of the purpose.
export interface ReportSaveRequest {
  listId?: number;
  parentFolderId?: string;
  purpose?: DocumentOutputPurpose;
}
